import CustomButton from 'components/Buttons/CustomButton'
import { stepOrder } from 'features/private-views/purchase-commodity/purchaseCommoditySlice'
import { handlePathStorage } from 'helpers'
import { useAbilityAccess } from 'hooks/useAbilityAccess'
import { useState } from 'react'
import { Plus } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap'
import {
  BUSINESS_TRANSACTION_PURCHASE,
  BUSINESS_TRANSACTION_SELL,
  CREATE,
  MAKE,
  MANAGE,
} from 'utils/subjectActions'

const BtnMakeTransaction = ({ direction, ...props }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const toggle = () => setDropdownOpen((prevState) => !prevState)

  const [manualDropdownOpen, setManualDropdownOpen] = useState(false)
  const toggleManual = () => setManualDropdownOpen((prevState) => !prevState)

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const dashboard = useSelector((state) => state.dashboard)

  const lastPath = localStorage.getItem('lastPath')

  // Ability access hooks
  const createSell = useAbilityAccess({
    action: CREATE,
    subject: BUSINESS_TRANSACTION_SELL,
  })
  const makeSell = useAbilityAccess({
    action: MAKE,
    subject: BUSINESS_TRANSACTION_SELL,
  })
  const createPurchase = useAbilityAccess({
    action: CREATE,
    subject: BUSINESS_TRANSACTION_PURCHASE,
  })
  const makePurchase = useAbilityAccess({
    action: MAKE,
    subject: BUSINESS_TRANSACTION_PURCHASE,
  })
  const managePurchase = useAbilityAccess({
    action: MANAGE,
    subject: BUSINESS_TRANSACTION_PURCHASE,
  })

  const handlePurchaseClick = () => {
    if (makePurchase && !managePurchase) {
      dispatch(
        stepOrder({
          step: 1,
          type: 'BUY',
        }),
      )
      handlePathStorage(lastPath)
      navigate(`/purchase-commodity`)
    } else {
      handlePathStorage(lastPath)
      navigate(`/transaksi-pembelian-tambah-komoditas`)
    }
  }

  const handleSellClick = () => {
    handlePathStorage(lastPath)
    navigate(`/sell-commodity`)
  }

  return (
    <>
      {(createSell || createPurchase || makeSell || makePurchase) &&
        dashboard?.ownerData?.status === 'VERIFIED' && (
          <div className="d-flex flex-column gap-2 align-items-center">
            <Dropdown
              isOpen={dropdownOpen}
              toggle={toggle}
              direction={direction}
            >
              <DropdownToggle
                tag="div"
                className="border-0 bg-transparent p-0"
                caret={false}
              >
                <CustomButton color="primary" size="lg">
                  <Plus size={16} /> Buat Transaksi
                </CustomButton>
              </DropdownToggle>
              <DropdownMenu {...props}>
                {(createPurchase || makePurchase) && (
                  <DropdownItem onClick={handlePurchaseClick}>
                    <span className="text-sm">Pembelian</span>
                  </DropdownItem>
                )}
                {(createSell || makeSell) && (
                  <DropdownItem onClick={handleSellClick}>
                    <span className="text-sm">Penjualan</span>
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>

            <Dropdown
              isOpen={manualDropdownOpen}
              toggle={toggleManual}
              direction={direction}
            >
              <DropdownToggle
                tag="div"
                className="border-0 bg-transparent p-0"
                caret={false}
              >
                <CustomButton
                  color="link"
                  className="text-decoration-underline text-primary p-0"
                  size="sm"
                >
                  Buat Transaksi Manual
                </CustomButton>
              </DropdownToggle>
              <DropdownMenu {...props}>
                {(createPurchase || makePurchase) && (
                  <DropdownItem
                    onClick={() => {
                      navigate('/transaksi-pembelian-tambah-komoditas', {
                        state: { isManual: true },
                      })
                    }}
                  >
                    <span className="text-sm">Pembelian</span>
                  </DropdownItem>
                )}
                {(createSell || makeSell) && (
                  <DropdownItem
                    onClick={() => {
                      handlePathStorage(lastPath)
                      navigate(`/sell-commodity`, {
                        state: { isManual: true },
                      })
                    }}
                  >
                    <span className="text-sm">Penjualan</span>
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>
          </div>
        )}
    </>
  )
}

export default BtnMakeTransaction
